module.exports = __webpack_public_path__ + "img/20220412_094746.4d707bb1.jpg";